// extracted by mini-css-extract-plugin
var _1 = "_fqOJ";
var _2 = "GgMv_";
export { _1 as "base", _2 as "errorsList" }
